<template>
    <div class="banners no-trans" v-loading="loading">
        <el-carousel ref="hero_carousel" :autoplay="true" :loop="true" :style="{ '--banner-ratio': banner_ratio }" @touchstart.native.passive="banner_touch_start" @touchend.native.passive="banner_touch_end">
            <el-carousel-item v-for="(item, index) in banner_list" :key="index">
                <div class="banner_img">
                    <img :src="item.image" alt="" @load="index === 0 && (banner_ratio = $event.target.naturalWidth / $event.target.naturalHeight)">
                </div>
            </el-carousel-item>
        </el-carousel>
        <div class="banner_box" @mouseleave="mouseleave_type()">
            <div class="banner_flex">
                <div class="lefts">
                    <div class="tab_box">
                        <div class="title_box">
                            <div class="text1">热门咨询</div>
                            <div class="text2" @click="handle_qb">全部</div>
                        </div>
                        <div class="type_list_box">
                            <!-- @mouseenter和@mouseleave。 -->
                            <div class="type_list" v-for="(item, index) in type_list" :key="index"  @mouseenter="mouseenter_type(item,index)" @click="handle_type_path(item)" >
                                <div class="item_title">
                                    <img :src="item.icon" alt="">
                                    {{ item.title }}
                                </div>
                                <div class="item_list">
                                    <div class="items"
                                        v-for="(items, indexs) in item.child" :key="indexs" v-if="indexs<=2">
                                        <span class="span1">{{ items.title }}</span>
                                        <span class="span2"  v-if="indexs<2">
                                            <!-- {{ indexs != (item.child.length - 1) ? '|' : '' }} -->
                                              |
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="const" v-if="type_show" @click="handle_type_path(type_ac)">
                    <div class="const_tops">
                        <div class="c_type_title">{{ type_ac.title }}</div>
                        <div class="c_type_text">
                            {{ type_ac.desc }}
                        </div>
                        <div class="c_type_title2">细分领域</div>
                        <div class="c_type_list">
                            <div class="types" v-for="(item, index) in type_ac.child" :key="index">{{ item.title }}</div>
                        </div>
                    </div>
                    <div class="const_boms">
                        <div class="type_check">
                            <div class="icons">
                                <img src="../../assets/img/index/home/icon1.png" alt="">
                            </div>
                            <div class="texts">{{ type_ac.title }}在线咨询</div>
                        </div>
                        <div class="type_check">
                            <div class="icons">
                                <img src="../../assets/img/index/home/icon2.png" alt="">
                            </div>
                            <div class="texts">{{ type_ac.title }}相关律师</div>
                        </div>
                        <div class="type_check">
                            <div class="icons">
                                <img src="../../assets/img/index/home/icon4.png" alt="">
                            </div>
                            <div class="texts">{{ type_ac.title }}相关回答</div>
                        </div>
                        <div class="type_check">
                            <div class="icons">
                                <img src="../../assets/img/index/home/icon3.png" alt="">
                            </div>
                            <div class="texts">{{ type_ac.title }}法律知识</div>
                        </div>
                       
                    </div>
                    <!-- {{ type_ac }} -->

                </div>
                <div class="rights">
                    <div class="rights_box">
                        <div class="btn_box">
                            <div class="btns1" @click="$router.push('/online')">在线咨询</div>
                            <div class="btns2" @click="handle_ls_add" v-if="vuex_is_law_firm_apply!=1">律师入驻</div>
                        </div>
                        <div class="new_box" v-if="!mobile_view || new_lsit.length">
                            <div class="new_title_box">
                                <div class="title_icon"><img src="../../assets/img/index/home/new_icon.jpg" alt="">
                                </div>
                                <div class="title_text">资讯播报</div>
                            </div>
                            <div class="new_list" :style="{ '--news-height': ((new_lsit[0] || []).length * 56) + 'px' }">
                                <el-carousel direction="vertical" :autoplay="true" :loop="true">
                                    <el-carousel-item v-for="(item, index) in new_lsit" :key="index">
                                        <div class="new_item" v-for="(items, indexs) in item" :key="indexs" @click="handle_path(items)">
                                          {{ items.title }}
                                        </div>
                                    </el-carousel-item>
                                </el-carousel>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <agreement ref="agreement"  @handle_end="handle_end"></agreement>

         
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'

export default {
    components: {
    },
    name: "homes",
    data() {
        return {
            loading: false,
            banner_list: [],
            banner_ratio: 1920 / 521,
            banner_touch: null,
            type_show: false,
            type_ac: {},
            type_list: [
                // {
                //     title: '婚姻家庭',
                //     img_src: require('../../assets/img/index/home/type1.png'),
                //     text: '离婚财产纠纷、离婚子女抚养纠纷、婚约财产纠纷、离婚后财产纠纷、离婚后债务承担纠纷等的法律服务。',
                //     list: [
                //         {
                //             title: '婚姻纠纷',

                //         },
                //         {
                //             title: '继承纠纷',
                //         },
                //         {
                //             title: '家事纠纷',
                //         }
                //     ],
                // },
                // {
                //     title: '债权债务',
                //     img_src: require('../../assets/img/index/home/type2.png'),
                //     list: [
                //         {
                //             title: '借贷债务',

                //         }
                //     ],
                // },
                // {
                //     title: '劳动工伤',
                //     img_src: require('../../assets/img/index/home/type3.png'),
                //     list: [
                //         {
                //             title: '劳动争议',

                //         },
                //         {
                //             title: '人事争议',
                //         }
                //     ],
                // },
                // {
                //     title: '刑事辩护',
                //     img_src: require('../../assets/img/index/home/type1.png'),
                //     list: [
                //         {
                //             title: '危险驾驶',
                //         },
                //         {
                //             title: '抢劫罪',
                //         },
                //         {
                //             title: '交通肇事',
                //         }
                //     ],
                // },
                // {
                //     title: '非诉服务',
                //     img_src: require('../../assets/img/index/home/type1.png'),
                //     list: [
                //         {
                //             title: '法律咨询',
                //         },
                //         {
                //             title: '协商谈判',
                //         },
                //         {
                //             title: '其他法律',
                //         }
                //     ],
                // },
                // {
                //     title: '法律顾问',
                //     img_src: require('../../assets/img/index/home/type1.png'),
                //     list: [
                //         {
                //             title: '企业协商',
                //         },
                //         {
                //             title: '企业知识',
                //         },
                //         {
                //             title: '企业专项',
                //         }
                //     ],
                // },
                // {
                //     title: '活动产品',
                //     img_src: require('../../assets/img/index/home/huodong.png'),
                //     list: [

                //     ],
                // }
            ],
            new_lsit: [],
           
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number','vuex_is_law_firm_apply'])
    },
    watch: {

    },
    created() {
        this.get_banner()
        this.get_type()
        this.get_new_list()
    },
    methods: {
        banner_touch_start(event) {
            if (!this.mobile_view || event.touches.length !== 1) return
            this.banner_touch = { x: event.touches[0].clientX, y: event.touches[0].clientY }
        },
        banner_touch_end(event) {
            const start = this.banner_touch
            this.banner_touch = null
            if (!this.mobile_view || !start || !event.changedTouches.length) return
            const dx = event.changedTouches[0].clientX - start.x
            const dy = event.changedTouches[0].clientY - start.y
            if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
                this.$refs.hero_carousel[dx < 0 ? 'next' : 'prev']()
            }
        },
        handle_qb(){
            console.log('全部')
            this.$router.push({
                path:'/enterprise_list',
            })
        },
        handle_type_path(item){
            console.log('item',item)
            if(item.type==2){
                
                this.$router.push({
                    path:'/individual_list',
                    query:{
                        id:item.id
                    }
                })
            }else{
                this.$router.push({
                    path:'/enterprise_list',
                    query:{
                        id:item.id
                    }
                })
            }
        },
        get_banner(){
            this.loading=true
            this.$api("getBanner", {
                position:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('banners',res)
                if (res.code == 1) {
                   this.banner_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_type(){
            this.loading=true
            this.$api("cause", {
                 
			}, "get").then((res) => {
                this.loading = false
                console.log('首页分类',res)
                if (res.code == 1) {
                    this.type_list=res.data.splice(0,7)
                   
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_new_list(){
            this.loading=true
            this.$api("getArticleList", {
                category_id:5,
                limit:100,
			}, "get").then((res) => {
                this.loading = false
                console.log('资讯播报',res)
                if (res.code == 1) {
                    let data = res.data.list
                    let index = 0;
                    let newArray = [];
                    while(index < data.length) {
                        newArray.push(data.slice(index, index += 4));
                    }
                    console.log('newArray',newArray)
                    this.new_lsit=newArray
                } else {
                    alertErr(res.msg)
                }
            });
        },
        mouseenter_type(item,index) {
            if (this.mobile_view) return
            // console.log('鼠标划入', item)
            if(index==this.type_list.length-1){
                return
            }
            this.type_show = true
            this.type_ac = item
        },
        mouseleave_type() {
            // console.log('鼠标划出')
            this.type_show = false
        },
        handle_ls_add(){
            console.log('点击')
            this.$refs.agreement.handle_open()

            
        },
        handle_end(){
            this.$api("getUserInfo", {
              
			}, "get").then((res) => {
                this.loading = false
                console.log('地址',res)
                if (res.code == 1) {
                    this.$emit('handle_lvshi_add')
                } else {
                    alertErr(res.msg)
                    if(res.msg=='请登录'){
                        this.$router.push({
                            path:'/login'
                        })
                    }
                }
            });
        },
        handle_path(item){
            this.$router.push({
                path:'/hot_spot_type_detial',
                query:{
                    id:item.id
                },
            })
        },
    },

}
</script>
<style scoped lang="less">
 .banners {
        position: relative;

        /deep/.el-carousel {
            height: 521px;
            // overflow: visible;
            overflow: hidden;

            .el-carousel__container {
                height: 100%;

                .banner_img {
                    width: 100%;
                    height: 100%;

                    img {
                        width: 100%;
                        height: 100%;
                    }

                }
            }

            .el-carousel__indicators {
                // position: relative;
                z-index: 101;
                // margin-top: 20px;
                bottom: -5px;

                .el-carousel__indicator {
                    .el-carousel__button {
                        width: 10px;
                        height: 10px;
                        background: #FFFFFF;
                        border-radius: 50%;
                    }
                }

                .is-active {
                    .el-carousel__button {
                        width: 40px;
                        height: 10px;
                        background: #377CFD;
                        border-radius: 5px 5px 5px 5px;
                        // .opacity
                        opacity: 1;
                    }
                }
            }
        }
        .banner_box {
            width: 100%;
            position: absolute;
            top: 0;
            z-index: 100;

            .banner_flex {
                width: 1440px;
                height: 521px;
                margin: auto;
                // background-color: red;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .lefts {
                    .tab_box {
                        width: 260px;
                        height: 470px;
                        background: #FFFFFF;
                        border-radius: 8px 8px 8px 8px;
                        padding: 20px 20px 36px 20px;

                        .title_box {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;

                            .text1 {
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 16px;
                                color: #333333;
                            }

                            .text2 {
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #377CFD;
                                cursor: pointer;
                            }
                        }

                    }

                    .type_list_box {
                        padding-top: 20px;

                        .type_list {
                            margin-bottom: 18px;

                            .item_title {
                                display: flex;
                                align-items: center;
                                cursor: pointer;
                                img {
                                    width: 16px;
                                    // height: 16px;
                                    margin-right: 8px;
                                }
                            }

                            .item_list {
                                display: flex;
                                align-items: center;
                                flex-wrap: wrap;
                                padding-top: 5px;

                                .items {
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 12px;
                                    color: #999999;

                                    .span1 {
                                        // width: 60px;
                                        // display: inline-block;
                                        cursor: pointer;
                                    }

                                    .span1:hover {
                                        color: #050505;
                                    }

                                    .span2 {
                                        padding-right: 5px;
                                    }
                                }
                            }
                        }
                    }
                }

                .const {
                    width: 904px;
                    height: 470px;
                    background: #FFFFFF;
                    border-radius: 8px 8px 8px 8px;
                    padding: 24px 40px;
                    display: flex;
                    align-content: space-between;
                    flex-wrap: wrap;

                    .const_tops {
                        width: 100%;

                        .c_type_title {
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 20px;
                            color: #377CFD;
                        }

                        .c_type_text {
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #333333;
                            padding-top: 17px;
                        }

                        .c_type_title2 {
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #666666;
                            padding-top: 40px;
                        }

                        .c_type_list {
                            display: flex;
                            align-items: center;
                            padding-top: 16px;

                            .types {
                                width: 128px;
                                height: 36px;
                                background: #FFFFFF;
                                border-radius: 18px 18px 18px 18px;
                                border: 1px solid #B8C4D1;
                                text-align: center;
                                line-height: 36px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #666666;
                                margin-right: 20px;
                                cursor: pointer;
                            }
                        }
                    }

                    .const_boms {
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: space-around;
                        padding-top: 40px;
                        border-top: 2px solid #EEEEEE;

                        .type_check {
                            cursor: pointer;

                            .icons {
                                text-align: center;

                                img {
                                    height: 41px;
                                }
                            }

                            .texts {
                                padding-top: 20px;
                                text-align: center;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #666666;
                            }
                        }
                    }

                }

                .rights {
                    .rights_box {
                        width: 260px;
                        height: 470px;
                        background: #FFFFFF;
                        border-radius: 8px 8px 8px 8px;
                        padding: 32px 24px;

                        .btn_box {
                            padding-bottom: 33px;
                            border-bottom: 2px solid #EFEFEF;

                            .btns1 {
                                width: 212px;
                                height: 40px;
                                background: #FFAA00;
                                border-radius: 20px 20px 20px 20px;
                                text-align: center;
                                line-height: 40px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 14px;
                                color: #FFFFFF;
                                cursor: pointer;

                            }

                            .btns2 {
                                width: 212px;
                                height: 40px;
                                background: #377CFD;
                                border-radius: 20px 20px 20px 20px;
                                margin-top: 24px;
                                text-align: center;
                                line-height: 40px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 14px;
                                color: #FFFFFF;
                                cursor: pointer;
                            }
                        }

                        .new_box {
                            .new_title_box {
                                display: flex;
                                align-items: center;
                                padding-top: 24px;
                                padding-bottom: 25px;

                                .title_icon {
                                    width: 21px;

                                    // height: 17px;
                                    img {
                                        width: 21px;
                                        // height: 17px;
                                        vertical-align: middle;
                                    }
                                }

                                .title_text {
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: bold;
                                    font-size: 14px;
                                    color: #333333;
                                    padding-left: 2px;
                                }
                            }

                            .new_list {
                                /deep/.el-carousel {
                                    height: 210px;

                                    .el-carousel__indicators {
                                        display: none;
                                    }
                                }

                                .new_item {
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 12px;
                                    color: #999999;
                                    margin-bottom: 20px;
                                    padding-right: 10px;
                                    cursor: pointer;
                                }
                            }
                        }
                    }
                }
            }

        }

    }
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .banners.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .banners.no-trans /deep/ .el-carousel {
        height: 521px;
    }
    .banners.no-trans /deep/ .el-carousel .el-carousel__indicators {
        bottom: -5px;
    }
    .banners.no-trans /deep/ .el-carousel .el-carousel__indicators .el-carousel__indicator .el-carousel__button {
        width: 10px;
        height: 10px;
        border-radius: 50%;
    }
    .banners.no-trans /deep/ .el-carousel .el-carousel__indicators .is-active .el-carousel__button {
        width: 40px;
        height: 10px;
        border-radius: 5px 5px 5px 5px;
    }
    .banners.no-trans .banner_box .banner_flex {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        margin: auto;
        flex-wrap: wrap;
        gap: 8px;
    }
    .banners.no-trans .banner_box .banner_flex .lefts .tab_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 8px 8px 8px 8px;
        padding: 16px 16px 16px 16px;
    }
    .banners.no-trans .banner_box .banner_flex .lefts .tab_box .title_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .banners.no-trans .banner_box .banner_flex .lefts .tab_box .title_box .text1 {
        font-size: 16px;
    }
    .banners.no-trans .banner_box .banner_flex .lefts .tab_box .title_box .text2 {
        font-size: 14px;
    }
    .banners.no-trans .banner_box .banner_flex .lefts .type_list_box {
        padding-top: 16px;
    }
    .banners.no-trans .banner_box .banner_flex .lefts .type_list_box .type_list {
        margin-bottom: 16px;
    }
    .banners.no-trans .banner_box .banner_flex .lefts .type_list_box .type_list .item_title {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .banners.no-trans .banner_box .banner_flex .lefts .type_list_box .type_list .item_title img {
        width: 16px;
        margin-right: 8px;
    }
    .banners.no-trans .banner_box .banner_flex .lefts .type_list_box .type_list .item_list {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 5px;
    }
    .banners.no-trans .banner_box .banner_flex .lefts .type_list_box .type_list .item_list .items {
        font-size: 14px;
    }
    .banners.no-trans .banner_box .banner_flex .lefts .type_list_box .type_list .item_list .items .span2 {
        padding-right: 5px;
    }
    .banners.no-trans .banner_box .banner_flex .const {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 8px 8px 8px 8px;
        padding: 16px 16px;
        flex-wrap: wrap;
        gap: 8px;
    }
    .banners.no-trans .banner_box .banner_flex .const .const_tops .c_type_title {
        font-size: 20px;
    }
    .banners.no-trans .banner_box .banner_flex .const .const_tops .c_type_text {
        font-size: 14px;
        padding-top: 16px;
    }
    .banners.no-trans .banner_box .banner_flex .const .const_tops .c_type_title2 {
        font-size: 14px;
        padding-top: 16px;
    }
    .banners.no-trans .banner_box .banner_flex .const .const_tops .c_type_list {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .banners.no-trans .banner_box .banner_flex .const .const_tops .c_type_list .types {
        width: 128px;
        height: 36px;
        border-radius: 8px 8px 8px 8px;
        line-height: 36px;
        font-size: 14px;
        margin-right: 16px;
    }
    .banners.no-trans .banner_box .banner_flex .const .const_boms {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .banners.no-trans .banner_box .banner_flex .const .const_boms .type_check .icons img {
        height: 41px;
    }
    .banners.no-trans .banner_box .banner_flex .const .const_boms .type_check .texts {
        padding-top: 16px;
        font-size: 14px;
    }
    .banners.no-trans .banner_box .banner_flex .rights .rights_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 8px 8px 8px 8px;
        padding: 16px 16px;
    }
    .banners.no-trans .banner_box .banner_flex .rights .rights_box .btn_box {
        padding-bottom: 16px;
    }
    .banners.no-trans .banner_box .banner_flex .rights .rights_box .btn_box .btns1 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 8px 8px 8px 8px;
        line-height: 1.6;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .banners.no-trans .banner_box .banner_flex .rights .rights_box .btn_box .btns2 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 8px 8px 8px 8px;
        margin-top: 16px;
        line-height: 1.6;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .banners.no-trans .banner_box .banner_flex .rights .rights_box .new_box .new_title_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
        padding-bottom: 16px;
    }
    .banners.no-trans .banner_box .banner_flex .rights .rights_box .new_box .new_title_box .title_icon {
        width: 21px;
    }
    .banners.no-trans .banner_box .banner_flex .rights .rights_box .new_box .new_title_box .title_icon img {
        width: 21px;
    }
    .banners.no-trans .banner_box .banner_flex .rights .rights_box .new_box .new_title_box .title_text {
        font-size: 14px;
        padding-left: 2px;
    }
    .banners.no-trans .banner_box .banner_flex .rights .rights_box .new_box .new_list /deep/ .el-carousel {
        height: 210px;
    }
    .banners.no-trans .banner_box .banner_flex .rights .rights_box .new_box .new_list .new_item {
        font-size: 14px;
        margin-bottom: 16px;
        padding-right: 10px;
    }
}
@media (max-width: 1024px) {
    .banners.no-trans {
        /deep/ .el-carousel { height: auto; }
        /deep/ .el-carousel .el-carousel__container { height: 100%; }
        > .el-carousel /deep/ .el-carousel__container { height: auto; aspect-ratio: var(--banner-ratio); }
        > .el-carousel /deep/ .banner_img img { display: block; object-fit: contain; }
        > .el-carousel /deep/ .el-carousel__indicators { bottom: 0; display: flex; align-items: center; }
        > .el-carousel /deep/ .el-carousel__indicator { padding: 10px 5px; }
        > .el-carousel /deep/ .el-carousel__indicator .el-carousel__button { width: 6px; height: 6px; }
        > .el-carousel /deep/ .el-carousel__indicator.is-active .el-carousel__button { width: 18px; height: 6px; }
        .banner_box {
            position: relative; top: auto;
            .banner_flex {
                width: 100%; height: auto; padding: 16px 20px; gap: 16px; align-items: stretch;
                .lefts, .rights { width: 100%; }
                .lefts .tab_box { width: 100%; height: auto; padding: 0; background: transparent; }
                .lefts .tab_box .title_box { align-items: center; padding-bottom: 8px; }
                .lefts .tab_box .title_box .text1 { font-size: 18px; line-height: 28px; }
                .lefts .tab_box .title_box .text2 { display: flex; align-items: center; min-height: 44px; padding: 0 4px 0 12px; font-size: 14px; }
                .lefts .tab_box .type_list_box { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }
                .lefts .tab_box .type_list_box .type_list { height: auto; min-height: 76px; padding: 12px 10px; margin: 0; background: #f5f8ff; border: 1px solid #e8eef8; border-radius: 6px; }
                .lefts .tab_box .type_list_box .type_list:last-child:nth-child(odd) { grid-column: ~"1 / -1"; min-height: 44px; }
                .lefts .tab_box .type_list_box .type_list .item_title { flex-wrap: nowrap; gap: 6px; }
                .lefts .tab_box .type_list_box .type_list .item_title { font-size: 15px; font-weight: 600; line-height: 24px; color: #27364b; }
                .lefts .tab_box .type_list_box .type_list .item_title img { width: 20px; height: 20px; object-fit: contain; flex-shrink: 0; margin-right: 0; }
                .lefts .tab_box .type_list_box .type_list .item_list { display: block; height: auto; padding-top: 4px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; line-height: 22px; color: #6b7484; }
                .lefts .tab_box .type_list_box .type_list .item_list .items { display: inline; font-size: 13px; }
                .const { display: none; }
                .rights .rights_box { width: 100%; height: auto; padding: 0; background: transparent; }
                .rights .rights_box .btn_box { display: flex; gap: 12px; padding-bottom: 0; }
                .rights .rights_box .btn_box .btns1, .rights .rights_box .btn_box .btns2 { flex: 1; width: auto; min-height: 44px; line-height: 20px; padding: 12px 8px; margin: 0; }
                .rights .rights_box .new_box { margin-top: 16px; padding-top: 16px; border-top: 1px solid #e8edf3; }
                .rights .rights_box .new_box .new_title_box { flex-wrap: nowrap; gap: 8px; padding: 0 0 8px; }
                .rights .rights_box .new_box .new_title_box .title_text { padding: 0; font-size: 18px; line-height: 28px; }
                .rights .rights_box .new_box .new_title_box .title_icon img { display: block; }
                .rights .rights_box .new_box .new_list /deep/ .el-carousel,
                .rights .rights_box .new_box .new_list /deep/ .el-carousel__container { height: var(--news-height, 224px); }
                .rights .rights_box .new_box .new_list .new_item {
                    display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2;
                    box-sizing: border-box; overflow: hidden; height: 56px; margin: 0; padding: 6px 0;
                    border-bottom: 1px solid #edf0f5; font-size: 14px; line-height: 22px; color: #39475a;
                }
            }
        }
    }
}
@media (max-width: 768px) {
    .banners.no-trans .banner_box .banner_flex { padding: 16px; }
}
</style>
